import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/visit-summary-notes/`;

export const visitSummaryNotes = {
  get: () => generateApiPath(pathBase),
};
